import { gql } from '@apollo/client';

import { NBJMenuLists } from '../fragments/header';

export const getMenuList = gql`
  ${NBJMenuLists}
  query getMenuList($usePreview: Boolean, $menuType: String) {
    NBJMenuList(usePreview: $usePreview, menuType: $menuType) {
      ...NBJMenuLists
    }
  }
`;
